/* 
Author:Lamiaa Moustafa
Desc: Contact page UI
*/

import React from "react";
import { Footer1st2911 } from "../../components/Footer1st2911";
import { FormInput } from "../../components/inputs/FormInput";
import{ Button1st2911} from "../../components/buttons/Button1st2911"
import { FormTextarea } from "../../components/inputs/FormTextarea";
import Text1st2911  from "../../components/text/Text1st2911";
import {SubmitDiv } from "../../Styles/styledComponents/Divs";
import {MainContainer } from "../../Styles/styledComponents/Section";
import {ContactForm} from "../../Styles/styledComponents/Form"
import { ImageDiv } from "../../Styles/styledComponents/BgImage";

const Contact = () => {
  return (
    <>
      <MainContainer>
        <ImageDiv></ImageDiv>
        {/* this is a form styled component */}
       <ContactForm> 
        <Text1st2911 data={{text:"Need Support?"}}/>
        <Text1st2911 data={{text:"Contact us if you need further assistance"}}/>
        <FormInput data={{name:"name", width:"100%",label:"Full name"}}/>
        <FormInput data={{name:"name", width:"100%",label:"Email address"}}/>
        <FormInput data={{name:"name", width:"100%",label:"Phone number"}}/>
        <FormTextarea data={{label:"Message", width:"100%", maxLength:"500"}}/>
        <SubmitDiv><Button1st2911 data={{ label:"SUBMIT"}}/></SubmitDiv>
       </ContactForm>
      </MainContainer>
      <Footer1st2911/>
    </>
  );
};

export default Contact;